import * as React from "react";

export type AccountStatus = "active" | "banned";

const STATUS_LABELS: Record<AccountStatus, string> = {
  active: "Активен",
  banned: "Заблокирован",
};

// Darker text on tinted backgrounds for WCAG 2.2 AA 4.5:1 contrast on small text.
const STATUS_CLASS: Record<AccountStatus, string> = {
  active:
    "text-[#0d6e3e] bg-[rgba(26,138,82,0.08)] before:bg-[var(--success)]",
  banned:
    "text-[#a02d1f] bg-[rgba(196,58,42,0.08)] before:bg-[var(--danger)]",
};

interface AccountStatusPillProps {
  status: AccountStatus;
}

export function AccountStatusPill({
  status,
}: AccountStatusPillProps): React.JSX.Element {
  return (
    <span
      className={[
        "inline-flex items-center gap-1.5 text-[12px] font-[500] px-2.5 py-0.5 rounded-full whitespace-nowrap",
        "before:content-[''] before:w-1.5 before:h-1.5 before:rounded-full before:flex-shrink-0",
        STATUS_CLASS[status],
      ].join(" ")}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
